<template>
    <SiteNavigation
        :floating-logo="themeSetting('logo_type') == 1 ? true : false"
        :centered-logo="themeSetting('center_logo') == 1 && !themeSetting('powered_by_monevo') ? true : false"
        :transparent-header="themeSetting('transparent_header') == 1 ? true : false"
    >
        <template v-slot:logo>
            <ConditionalLink
                v-if="!isStaticPage && isLogoClickEnabled"
                :type="themeSetting('partner_callback_url') ? 'external' : null"
                :link="themeSetting('partner_callback_url') || url('/')"
                :router="false"
                :target="homepageLogoTargetBlank"
            >
                <img :src="themeSetting('logo')" alt="Monevo" v-if="themeSetting('logo')" />
                <img :src="asset('/img/logos/logo-monevo.svg?v=2')" alt="Monevo" v-else />
            </ConditionalLink>

            <div v-else class="image-container">
                <img :src="themeSetting('logo')" alt="Monevo" v-if="themeSetting('logo')" />
                <img :src="asset('/img/logos/logo-monevo.svg?v=2')" alt="Monevo" v-else />
            </div>
        </template>

        <template v-slot:navigation>
            <li
                v-for="(menuItem, index) in primaryMenu"
                :key="index"
                :class="`nav-list__item ${(menuMisc.activeMenuItemParent == menuItem.name && 'is-active') || ''}
        ${
            !menuMisc.showLegalTextLabel && !menuMisc.showNavigationCta && index != primaryMenu.length - 1 ? 'last' : ''
        }`"
            >
                <div v-if="showNavigation">
                    <a class="nav-list__link" :href="menuItem.url">
                        {{ menuItem.name }}
                        <span
                            v-if="menuItem.children.length"
                            class="nav-list__icon icon icon-caret-down"
                            aria-hidden="true"
                        ></span>
                    </a>

                    <div class="menu" v-if="menuItem.children.length">
                        <ul class="menu__list">
                            <li
                                v-for="(menuItem, index) in menuItem.children"
                                :key="index"
                                :class="`menu__item ${menuMisc.activeMenuItemChild == menuItem.name && 'is-active'}`"
                            >
                                <a class="menu__link" :href="menuItem.url">{{ menuItem.name }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </li>

            <li v-if="menuMisc.showNavigationCta && menuMisc.navigationCtaSlug && showNavigation">
                <router-link
                    :to="forceRelativeUrl(url(menuMisc.navigationCtaSlug))"
                    class="nav-button button large bordered"
                >
                    {{ menuMisc.navigationCtaText }}
                </router-link>
            </li>
        </template>

        <template v-slot:co-branding-logo>
            <div v-if="themeSetting('powered_by_monevo') || coBranding?.logo">
                <PartnerLogo alignment="right" :isStaticPage="isStaticPage" />
            </div>
            <TerritoryToggle alignment="right" />
        </template>
    </SiteNavigation>
</template>

<script>
import { useStore } from 'vuex'

export default {
    props: ['isStaticPage'],
    setup() {
        const store = useStore()

        return {
            store,
        }
    },
    computed: {
        pageData: function () {
            return this.store.state.global.page || null
        },
        isLogoClickEnabled: function () {
            return parseInt(this.themeSetting('disable_logo_click')) !== 1
        },
        menu: function () {
            return this.store.state.global.data.menu || {}
        },
        primaryMenu: function () {
            return this.menu.primary || false
        },
        menuMisc: function () {
            return this.menu.misc || {}
        },
        showNavigation: function () {
            if (
                this.themeSetting('menu') === 0 ||
                (this.pageData && this.pageData.hide_primary_navigation === 1) ||
                (this.pageData && this.pageData.template === 'result_page') ||
                this.pageData.template === 'rates_table'
            ) {
                return false
            }

            return true
        },
        coBranding: function () {
            if (this.pageData && this.pageData.cobranding_logo) {
                return {
                    logo: this.pageData && this.pageData.cobranding_logo,
                    text: this.pageData && this.pageData.cobranding_text,
                }
            }

            return null
        },
        homepageLogoTargetBlank: function () {
            return this.themeSetting('homepage_logo_target_blank') === '1' ? '_blank' : ''
        },
    },
}
</script>
